import React from "react";

function ConfirmDeleteModal({ open, name, type, onCancel, onConfirm }) {
  if (!open) return null;
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(30,41,59,0.25)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          background: "white",
          borderRadius: 18,
          boxShadow: "0 8px 32px 0 rgba(31,38,135,0.18)",
          padding: "2.5rem 2.5rem 2rem 2.5rem",
          minWidth: 340,
          maxWidth: "90vw",
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div style={{ fontSize: 38, marginBottom: 12 }}>🗑️</div>
        <h2
          style={{ margin: 0, fontWeight: 700, fontSize: 22, color: "#dc2626" }}
        >
          Delete {type === "file" ? "File" : "Folder"}?
        </h2>
        <p style={{ color: "#64748b", margin: "18px 0 28px 0", fontSize: 16 }}>
          Are you sure you want to delete <b>{name}</b>{" "}
          {type === "file" ? "file" : "folder and all its contents"}? This
          action cannot be undone.
        </p>
        <div style={{ display: "flex", gap: 18, marginTop: 8 }}>
          <button
            className="btn btn-secondary btn-sm"
            style={{ minWidth: 90, fontWeight: 600, borderRadius: 8 }}
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            className="btn btn-danger btn-sm"
            style={{ minWidth: 90, fontWeight: 600, borderRadius: 8 }}
            onClick={onConfirm}
          >
            Yes, Delete
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmDeleteModal;
